import { YANDEX_METRIKA_ID } from '../config';

type GoalType = 'click' | 'focus' | 'input' | 'other';

export default class YandexTrackingService {
  setTrackingGoal(goal: string, goalType: GoalType, params?: Record<string, unknown>): void {
    if (!window.ym) {
      return;
    }

    if (params) {
      window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal, params);
    } else {
      window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal);
    }

    console.log(`${goalType} ${goal}`);
  }
}

const yandexTrackingService = new YandexTrackingService();

export { yandexTrackingService };
